module.exports = __webpack_public_path__ + "static/media/sautizabusara.12309469.png";